import React, { useState } from 'react'
import { Button, Col, Drawer, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import AddDurableArticlesTable from '../addDurableArticlesWidget/AddDurableArticlesTable'
import AssetHistoryTable from './AssetHistoryTable'
import { assetHistotry } from '../../../redux/actions/addDurableArticles'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'
import { budgetFormat } from '../../../utils/formatterUtil'
import MiniProjectInfo from '../../projectBasedItemsWidget/MiniProjectInfo'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function AddDurableArticlesWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [formSchema, setFormSchema] = useState(props.schema)
  const [isShowHistory, setIsShowHistory] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const [historySchema, setHistorySchema] = useState()

  const onViewHistory = async (id) => {
    setIsShowHistory(true)
    setIsLoading(true)
    startLoading()

    try {
      var response = await assetHistotry(id)
      if (response.model) {
        setHistorySchema(response.model)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
        setIsShowHistory(false)
      }
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
      setIsShowHistory(false)
    }

    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={formSchema.header} bordered>
        {!formSchema?.form?.isSupplyOfficer && formSchema?.projectInfo && (
          <MiniProjectInfo schema={formSchema?.projectInfo} />
        )}

        <AddDurableArticlesTable
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          schema={formSchema?.form}
          isViewMode={!formSchema?.form?.isEnableEdit}
          onViewHistory={onViewHistory}
          pagination={formSchema?.form?.isSupplyOfficer}
        />

        <Drawer
          full
          // size="lg"
          show={isShowHistory}
          placement={'top'}
          onHide={() => {
            setIsShowHistory(false)
          }}
        >
          <Drawer.Header>
            <Drawer.Title style={{ height: 40, paddingTop: 10 }}>ประวัติครุภัณฑ์</Drawer.Title>
          </Drawer.Header>
          <Drawer.Body>
            {historySchema?.assetInfo && (
              <div style={{ width: '98%' }}>
                {historySchema.assetInfo.assetCode && (
                  <Row>
                    <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                      <b>{historySchema.assetInfo.assetCode.label}</b>
                    </Col>
                    <Col lg={20} md={20} sm={24} xs={24}>
                      {historySchema.assetInfo.assetCode.value}
                    </Col>
                  </Row>
                )}

                {historySchema.assetInfo.assetName && (
                  <Row>
                    <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                      <b>{historySchema.assetInfo.assetName.label}</b>
                    </Col>
                    <Col lg={20} md={20} sm={24} xs={24}>
                      {historySchema.assetInfo.assetName.value}
                    </Col>
                  </Row>
                )}

                <Row>
                  {historySchema.assetInfo.assetType && (
                    <>
                      <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                        <b>{historySchema.assetInfo.assetType.label}</b>
                      </Col>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        {historySchema.assetInfo.assetType.value}
                      </Col>
                    </>
                  )}

                  {historySchema.assetInfo.price && (
                    <>
                      <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                        <b>{historySchema.assetInfo.price.label}</b>
                      </Col>
                      <Col lg={8} md={8} sm={24} xs={24}>
                        {budgetFormat(historySchema.assetInfo.price.value)}
                      </Col>
                    </>
                  )}
                </Row>

                <br />
              </div>
            )}

            <AssetHistoryTable datas={historySchema?.values} loading={isLoading} />
          </Drawer.Body>
          <Drawer.Footer>
            <CancelButton
              onClick={(e) => {
                setIsShowHistory(false)
              }}
              children="ปิด"
            />
          </Drawer.Footer>
        </Drawer>
      </Panel>
    </>
  )
}
